var render, staticRenderFns
import script from "./StackBarChart.vue?vue&type=script&lang=js&"
export * from "./StackBarChart.vue?vue&type=script&lang=js&"
import style0 from "./StackBarChart.vue?vue&type=style&index=0&id=4c535f4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c535f4e",
  null
  
)

export default component.exports